import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaError, CaFormFieldComponent, CaLabel } from '@global-front-components/ui/form-field';
import { CaInputDirective } from '@global-front-components/ui/input';
import { TranslateModule } from '@ngx-translate/core';
import { DatosContacto } from '../../model/poliza.model';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CaCardComponent } from '@global-front-components/ui/card';

@Component({
	selector: 'app-datos-contacto',
	standalone: true,
	imports: [
		CommonModule,
		CaLabel,
		CaInputDirective,
		CaFormFieldComponent,
		ReactiveFormsModule,
		CaError,
		CaCardComponent,
		TranslateModule
	],
	templateUrl: './datos-contacto.component.html',
	styleUrls: ['./datos-contacto.component.scss']
})
export class DatosContactoComponent implements OnInit {
	@Input() datosContacto: DatosContacto = {};
	@Input() mostrarMensajeMail: boolean = false;
	@Input() form: FormGroup;
	@Input() editable = true;
	@Output() datosContactoChange = new EventEmitter<DatosContacto>();

	constructor(private fb: FormBuilder) { }

	ngOnInit(): void {
		if (!this.form) {
			this.form = this.fb.group({});
		}

		this.form.addControl('email', this.fb.control({
			value: this.datosContacto?.email?.direccion || '',
			disabled: !this.editable
		}));
		this.form.addControl('email-uso-contractual', this.fb.control({
			value: this.datosContacto?.email?.usoContractual || '',
			disabled: !this.editable
		}));

		this.form.addControl('movil', this.fb.control({
			value: this.datosContacto?.telefonoMovil?.numero || '',
			disabled: !this.editable
		}));
		this.form.addControl('movil-uso-contractual', this.fb.control({
			value: this.datosContacto?.telefonoMovil?.usoContractual || '',
			disabled: !this.editable
		}));

		this.form.addControl('fijo', this.fb.control({
			value: this.datosContacto?.telefonoFijo?.numero || '',
			disabled: !this.editable
		}));
		this.form.addControl('fijo-uso-contractual', this.fb.control({
			value: this.datosContacto?.telefonoFijo?.usoContractual || '',
			disabled: !this.editable
		}));
		this.form.valueChanges.subscribe(() => {
			this.emitirDatosContacto();
		});
	}

	private getDatosContacto(): DatosContacto | null {
		const email = this.form.get('email')?.value;
		const movil = this.form.get('movil')?.value;
		const fijo = this.form.get('fijo')?.value;

		const datosContacto: DatosContacto = {};
		if (email) {
			datosContacto.email = {
				direccion: email,
				usoContractual: true
			};
		}
		if (movil) {
			datosContacto.telefonoMovil = {
				numero: movil,
				usoContractual: true
			};
		}
		if (fijo) {
			datosContacto.telefonoFijo = {
				numero: fijo,
				usoContractual: true
			};
		}
		return Object.keys(datosContacto).length > 0 ? datosContacto : null;
	}

	emitirDatosContacto(): void {
		this.datosContactoChange.emit(this.getDatosContacto());
	}

}
